export default __webpack_public_path__ + "static/media/3photo(new).7a8b77f2.jpg";